import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _get from "lodash/get";
var _excluded = ["text", "url", "type"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import classnames from 'classnames';
import { Button } from "../../Button/Button/Button";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Image } from "../../Image/Image/Image";
import { OfferBanner } from "../../Banner/OfferBanner/OfferBanner";
import { ScrollTransform } from "../../ScrollTransform/ScrollTransform";
import { Text } from "../../Text/Text/Text";
import styles from "./SliceIntroBlock.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var sliceIntroBlockEyebrowTypogs = ['eyebrow1', 'eyebrow2', 'eyebrow3'];
var defaultEyebrowTypog = 'eyebrow3';
var defaultEyebrowVariant = 'default';
var defultHeadingTypog = 'headline3';
var defaultHeadingVariant = 'default';
var defaultSubheadingTypog = 'headline5';
var defaultSubheadingVariant = 'default';
var defaultOfferBannerTextTypog = 'bodycopyLarge';
var defaultBodyTypog = 'bodycopyLarge';
var defaultCtaType = 'primary';
export var defaultPropsSliceIntroBlock = {
  className: '',
  icon: {
    className: ''
  },
  eyebrow: {
    text: '',
    typog: defaultEyebrowTypog,
    variant: defaultEyebrowVariant,
    className: ''
  },
  heading: {
    ariaLevel: 3,
    text: '',
    typog: defultHeadingTypog,
    variant: defaultHeadingVariant,
    className: ''
  },
  subheading: {
    text: '',
    ariaLevel: 4,
    typog: defaultSubheadingTypog,
    variant: defaultSubheadingVariant,
    scrollTransformScale: false,
    className: ''
  },
  offerBanner: {
    text: {
      text: '',
      typog: defaultOfferBannerTextTypog
    },
    className: ''
  },
  body: {
    text: '',
    typog: defaultBodyTypog,
    scrollTransformScale: false,
    className: ''
  },
  cta: {
    accessibilityLabel: '',
    text: '',
    type: defaultCtaType,
    onClick: function onClick() {},
    className: ''
  }
};
export var SliceIntroBlock = function SliceIntroBlock(_ref) {
  var align = _ref.align,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? defaultPropsSliceIntroBlock.className : _ref$className,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? _objectSpread({}, defaultPropsSliceIntroBlock.icon) : _ref$icon,
    _ref$eyebrow = _ref.eyebrow,
    eyebrow = _ref$eyebrow === void 0 ? _objectSpread({}, defaultPropsSliceIntroBlock.eyebrow) : _ref$eyebrow,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? _objectSpread({}, defaultPropsSliceIntroBlock.heading) : _ref$heading,
    _ref$subheading = _ref.subheading,
    subheading = _ref$subheading === void 0 ? _objectSpread({}, defaultPropsSliceIntroBlock.subheading) : _ref$subheading,
    _ref$offerBanner = _ref.offerBanner,
    offerBanner = _ref$offerBanner === void 0 ? _objectSpread({}, defaultPropsSliceIntroBlock.offerBanner) : _ref$offerBanner,
    _ref$body = _ref.body,
    body = _ref$body === void 0 ? _objectSpread({}, defaultPropsSliceIntroBlock.body) : _ref$body,
    _ref$cta = _ref.cta,
    cta = _ref$cta === void 0 ? _objectSpread({}, defaultPropsSliceIntroBlock.cta) : _ref$cta;
  var scrollTransform = {
    startScrollPercent: 0,
    endScrollPercent: 0.5,
    transforms: [{
      transformFunction: 'scaleX',
      unit: '',
      startValue: 0.75,
      endValue: 1
    }, {
      transformFunction: 'scaleY',
      unit: '',
      startValue: 0.75,
      endValue: 1
    }]
  };
  var renderSubheading = function renderSubheading() {
    var alignValue = align ? align : 'left';
    var subheadingComponent = /*#__PURE__*/_jsx(HeadingText, {
      richText: true,
      className: classnames(styles.subheading, subheading.className),
      align: alignValue,
      typog: subheading !== null && subheading !== void 0 && subheading.typog ? subheading === null || subheading === void 0 ? void 0 : subheading.typog : defaultPropsSliceIntroBlock.subheading.typog,
      ariaLevel: subheading.ariaLevel,
      variant: subheading.variant,
      children: subheading.text
    });
    return subheading.scrollTransformScale ? /*#__PURE__*/_jsx(ScrollTransform, _objectSpread(_objectSpread({}, scrollTransform), {}, {
      children: subheadingComponent
    })) : subheadingComponent;
  };
  var renderBody = function renderBody() {
    var bodyTextComponent = /*#__PURE__*/_jsx(Text, {
      richText: true,
      className: classnames(styles.body, body.className),
      typog: body !== null && body !== void 0 && body.typog ? body === null || body === void 0 ? void 0 : body.typog : defaultPropsSliceIntroBlock.body.typog,
      children: body.text
    });
    return body.scrollTransformScale ? /*#__PURE__*/_jsx(ScrollTransform, _objectSpread(_objectSpread({}, scrollTransform), {}, {
      children: bodyTextComponent
    })) : bodyTextComponent;
  };
  var renderCTA = function renderCTA(cta) {
    if (!cta || !cta.text) {
      return null;
    }
    var text = cta.text,
      url = cta.url,
      type = cta.type,
      otherProps = _objectWithoutProperties(cta, _excluded);
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      url: url,
      type: type
    }, otherProps), {}, {
      children: text
    }));
  };
  var hasIntro = icon && icon.image1x || eyebrow && eyebrow.text || heading && heading.text || subheading && subheading.text || body && body.text || cta && cta.text;
  if (!hasIntro) {
    return null;
  }
  var alignProcessed = align ? align : undefined;
  return /*#__PURE__*/_jsxs("div", {
    className: classnames({
      [styles.wrapper]: true,
      [styles.alignLeft]: alignProcessed === 'left',
      [styles.alignCenter]: alignProcessed === 'center',
      [className]: className
    }),
    children: [icon && icon.image1x && /*#__PURE__*/_jsx("div", {
      className: classnames(styles.icon, icon.className),
      children: /*#__PURE__*/_jsx(Image, {
        alt: icon.alt,
        src: icon.image1x,
        width: icon.width || undefined,
        height: icon.height || undefined,
        loading: icon.loading || 'lazy',
        transformations: {
          image1x: {
            width: typeof icon.width === 'string' ? parseInt(icon.width, 10) || undefined : undefined
          },
          image2x: {
            width: typeof icon.width === 'string' ? parseInt(icon.width, 10) * 2 || undefined : undefined
          }
        },
        forceTwoXInSrc: true
      })
    }), eyebrow && eyebrow.text && /*#__PURE__*/_jsx(Text, {
      richText: true,
      className: classnames(styles.eyebrow, eyebrow.className),
      typog: eyebrow !== null && eyebrow !== void 0 && eyebrow.typog ? eyebrow === null || eyebrow === void 0 ? void 0 : eyebrow.typog : defaultPropsSliceIntroBlock.eyebrow.typog,
      variant: eyebrow.variant,
      children: eyebrow.text
    }), heading && heading.text && /*#__PURE__*/_jsx(HeadingText, {
      richText: true,
      className: classnames(styles.heading, heading.className),
      align: alignProcessed ? alignProcessed : 'left',
      typog: heading !== null && heading !== void 0 && heading.typog ? heading === null || heading === void 0 ? void 0 : heading.typog : defaultPropsSliceIntroBlock.heading.typog,
      ariaLevel: heading.ariaLevel,
      variant: heading.variant,
      children: heading.text
    }), subheading && subheading.text && renderSubheading(), body && body.text && renderBody(), offerBanner && (offerBanner.popup || offerBanner.text) && /*#__PURE__*/_jsx(OfferBanner, {
      className: classnames(styles.offerBanner, offerBanner.className),
      popup: _objectSpread({}, offerBanner.popup),
      text: {
        text: _get(offerBanner, 'text.text'),
        typog: _get(offerBanner, 'text.typog') || 'bodycopyLarge'
      }
    }), cta && cta.text && /*#__PURE__*/_jsx("div", {
      className: styles.ctaWrapper,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.cta,
        "data-e2e-name": cta.e2eName,
        children: renderCTA(cta)
      })
    })]
  });
};